import { cn } from "@/lib/utils";

export const Stepper = ({
  steps,
  current,
  onStep
}: {
  steps: number;
  current: number;
  onStep?: (step: number) => void;
}) => (
  <div className="inline-flex items-center flex-col">
    <div className="inline-flex items-center gap-2">
      {"*"
        .repeat(steps)
        .split("")
        .map((_, step) => (
          <div
            key={step}
            onClick={() => onStep && onStep(step)}
            className={cn(
              step < current ? "cursor-pointer" : "",
              "flex flex-col justify-center h-6 w-20"
            )}
          >
            <div
              className={cn(
                "h-2 rounded-lg",
                step === current ? "bg-green-500" : "bg-gray-200"
              )}
            ></div>
          </div>
        ))}
    </div>

    <div className="text-secondary-foreground text-sm">
      Step {current + 1} of {steps}
    </div>
  </div>
);
